<template>
  <portal to="sidebar-menu">
    <div>
      <slot name="before"></slot>
      <nav-list :items="navigationItems"></nav-list>
      <text-language-select/>
      <slot name="after"></slot>
    </div>
  </portal>
</template>
<script>
  import { setLocaleHeader } from 'src/services/apiConfig'
  import TextLanguageSelect from 'src/components/TextLanguageSelect'
  export default {
    name: 'job-board-details--left-menu',
    components: {
      TextLanguageSelect,
    },
    data () {
      return {
        navigationItems: [
          {
            type: 'group',
            name: this.$t('generic.settings')
          },
          {
            routeName: 'jobboard_dashboard',
            name: this.$t('jobBoard.details.menu.dashboard')
          },
          {
            routeName: 'jobboard_settings',
            name: this.$t('jobBoard.details.menu.edit'),
            hide: !this.$can('admin-jobboard-crud')
          },
          {
            routeName: 'jobboard_jobs',
            name: this.$t('jobBoard.details.menu.jobs'),
          },
          {
            routeName: 'jobboard_orders',
            name: this.$t('jobBoard.details.menu.orders'),
          },
          {
            routeName: 'jobboard_placeholders',
            name: this.$t('jobBoard.details.menu.placeholders'),
          },
          {
            routeName: 'jobboard_landing-pages',
            name: this.$t('jobBoard.details.menu.landingPages'),
          },
          {
            routeName: 'jobboard_logs',
            name: this.$t('jobBoard.details.menu.logs'),
            hide: !this.$can('admin-wip')
          },
          {
            name: this.$t('generic.delete.title'),
            hide: !this.$can('admin-jobboard-crud')
          }
        ]
      }
    },
  }
</script>
<style>
</style>
